(function() {
  var COOKIE_NAME = 'fs_referrer';
  var COOKIE_DAYS = 30;

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    return null;
  }

  function getUrlParam(name) {
    var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
    return results ? decodeURIComponent(results[1]) : null;
  }

  function isValidPartnerId(id) {
    return id && /^FS-\d{4}$/i.test(id.trim());
  }

  var ref = getUrlParam('ref');
  if (ref && isValidPartnerId(ref)) {
    setCookie(COOKIE_NAME, ref.trim().toUpperCase(), COOKIE_DAYS);
  }

  var referrerId = getCookie(COOKIE_NAME);
  if (referrerId) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { referrer_id: referrerId }
      })
    }).catch(function() {});
  }
})();